const medicineBazarSl = {
  search: {
    placeholders: [
      'ඖෂධයේ නාමයක් ටයිප් කරන්න...',
      'ජෙනෙරික් නාමයක් ටයිප් කරන්න...',
      'සමාගමේ නම ටයිප් කරන්න...',
      'වෙළඳ නාමය ටයිප් කරන්න...',
      'සාප්පු නාමය ටයිප් කරන්න...'
    ]
  },
  sidebar: {
    categoriesTitle: 'ප්‍රවර්ග',
    storesTitle: 'සාප්පු'
  },
  upload: {
    title: 'වෙද පොත උඩුගත කරන්න',
    subtitle: 'වෙදෙරු නියෝගය උඩුගත කර පහසුවෙන් ඖෂධ ඇණවුම් කරන්න',
    uploadedPrefix: '✓ උඩුගත කළ ගොනුව:',
    chooseFile: 'ගොනුව තෝරන්න',
    replaceFile: 'නව ගොනුව උඩුගත කරන්න'
  },
  store: {
    serviceAreaLabel: 'සේවා ප්‍රදේශය',
    nationwide: 'රට පුරා',
    medicineCountLabel: 'ඖෂධ',
    close: 'වසන්න',
    productsOfSuffix: 'ඖෂධ',
    descriptionPrefix: 'පහත',
    descriptionSuffix: 'ෆාර්මසි එකෙන් ලබා ගත හැකි සියලු ඖෂධ. ප්‍රවර්ග අනුව පෙරහන් කළ හැක.'
  },
  card: {
    addToCart: 'බෑගයට එකතු කරන්න'
  },
  empty: {
    title: 'ඖෂධ හමු නොවිනි',
    subtitle: 'කරුණාකර වෙනත් ප්‍රවර්ගයක හෝ ෆාර්මසි තෝරන්න'
  },
  prescriptionFlow: {
    successTitle: 'වෙද පොත සාර්ථකව උඩුගත විය!',
    instruction: 'ඖෂධ ඇණවුම දැමීමට පහත විස්තර පුරවන්න',
    step1: { title: 'ෆාර්මසි තෝරන්න', subtitle: 'කවර ෆාර්මසි එකෙන් මිලදී ගන්නේද?', next: 'ඊළඟ' },
    step2: {
      title: 'කාර්ය මාර්ග කාලය තෝරන්න',
      subtitle: 'කීය දින සඳහා ඖෂධ අවශ්‍යද?',
      fullCourse: 'සම්පූර්ණ කාලය',
      fiveDays: 'දින 5 සඳහා',
      tenDays: 'දින 10 සඳහා',
      customDays: 'අභිරුචි දින',
      customDaysLabel: 'කීය දින?',
      customDaysPlaceholder: 'උදා: 15',
      back: 'ආපසු',
      next: 'ඊළඟ'
    },
    step3: {
      title: 'ඇණවුම තහවුරු කරන්න',
      summaryTitle: 'ඔබගේ ඇණවුම් සාරාංශය:',
      pharmacyLabel: 'ෆාර්මසි',
      durationLabel: 'කාලය',
      prescriptionLabel: 'වෙද පොත',
      back: 'ආපසු',
      confirm: 'තහවුරු කරන්න'
    },
    snackbar: {
      successTitle: '🎉 ඇණවුම සාර්ථකව යවා ඇත!',
      message: 'ඔබ තෝරාගත් ෆාර්මසි ලඟදීම මිල සහ විස්තර සමඟ සම්බන්ධ කර ගනී.'
    }
  }
};

export default medicineBazarSl;


